import { render, staticRenderFns } from "./EspecialidadeEditar.vue?vue&type=template&id=19236351"
import script from "./EspecialidadeEditar.vue?vue&type=script&lang=js"
export * from "./EspecialidadeEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports